module.exports = __webpack_public_path__ + "img/9-1.bbbbf63d.png";